<script>
export default {
  name: "messageModalComponent",
  props: {
    id: {
      type: String,
      default: "messageModal",
      require: false,
    },
    title: {
      type: String,
      default: "",
      require: false,
    },
    body: String,
  },
};
</script>

<template>
  <div>
    <b-modal :id="id" hide-footer centered>
      <div
        class="modalCenteringDiv text-center mt-2 mb-5"
        style="font-weight: 500; font-size: 16px"
      >
        <div v-if="title" class="font-weight-700 pb-3 mt-n3">
          {{ title }}
        </div>
        <div style="white-space: pre-wrap;">
          {{ body }}
        </div>
      </div>
    </b-modal>
  </div>
</template>

<style scoped>
@media screen and (max-width: 991px) {
  ::v-deep #messageModal .modal-content {
    height: 10em;
  }

  ::v-deep #messageModal .modal-body {
    margin-bottom: 0;
  }
}
</style>
